import React, { useEffect } from "react";
import Header from "../BaseComponents/Header";
import FotterMain from "../BaseComponents/FotterMain";

import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { baseURL } from "../../networkCalls/index";
import { Helmet } from "react-helmet";
import SEO from "../BaseComponents/SEO";
import useSeo from "../BaseComponents/SEO";

const ExtendedWarranty = () => {
  const toTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    toTop();
  }, []);
  const tableData = [
    {
      name: " Brush Cutter",

      standard: "1",

      extended: "1",
    },
    {
      name: "Lawn Mower",

      standard: "2",

      extended: "1 + 1",
    },
    {
      name: "Tiller",

      standard: "2",

      extended: "1 + 1",
    },
    {
      name: "DCHH",

      standard: "1",

      extended: "1",
    },
    {
      name: "Genset",

      standard: "2",

      extended: "1 + 1",
    },
    {
      name: "Marine",

      standard: "6M",

      extended: "6M, 12M, 18M",
    },
  ];

  const seo = useSeo();
  const url = window.location.href;
  // console.log({url});
  const testurl =
  `${process.env.REACT_APP_PRO_MODE.replace(/\/$/, "")}${window.location.pathname}`;



  return (
    <>

<SEO
       url={testurl}
      />

      {/* <SEO
        title="Honda Warranty Extended | Buy Extended Warranty"
        description="Get the best offer of Extended Product Warranty from Honda India Power Products"
        name="HIPP - Honda India Power"
        url="https://www.hondaindiapower.com/extended-warranty"
        type="Website"
      /> */}
      <Header />
      <div className="">
        <img
          src="https://www.hondaindiapower.com/images/EWI.jpg"
          className="img-fluid"
          alt="Extended Warranty"
        />
      </div>
      <div className="innerpagebg pt-5 pb-5">
        <div className="container mb-4">
          <div className="row">
            <div className="col-12  m-auto">
              <div className="align-items-center text-center">
                <h1 className="h1_heading d-inline-block m-0 fw-bold text-uppercase">
                  <span className="txtred">EXTENDED</span>{" "}
                  <span className="txtdgray">WARRANTY</span>
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row ">
            <div className="col-lg-10 col-mg-12 col-sm-12 col-12  m-auto">
              <div className="row d-flex align-items-center">
                <div className="col-lg-7 pe-lg-0">
                  <div className="card p-5 rounded-0 shadow-sm">
                    <div className="txtred f28">WHY SHOULD I PURCHASE AN</div>
                    <div className="fw-bold f28 mt-3">EXTENDED WARRANTY</div>
                    <div className="mt-3 f16">
                      Upto 2 years* Standard Warranty + Extended Warranty upto 2
                      years*
                    </div>
                    <div class="table-responsive mt-4">
                      <table class="table table-bordered table-striped">
                        <thead class="">
                          <tr>
                            <th>Category</th>
                            <th>Standard Warranty</th>
                            <th>Extended Warranty</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableData.map((val, id) => {
                            return (
                              <tr key={id} className="f13 ">
                                <td className="txtred fw500">{val.name}</td>
                                <td>{val.standard}</td>
                                <td>{val.extended}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 ps-lg-0">
                  <div className="card rounded-0 shadow-sm">
                    <div className="p-4 d-flex align-items-center">
                      <div>
                        <LazyLoadImage
                          alt=""
                          effect="blur"
                          className="img-fluid me-2"
                          style={{ maxWidth: "60px" }}
                          src={`/images/warrenty-icon-1.png`}
                        />
                      </div>
                      <div className="f16">
                        Peace of mind assured with Honda
                        <br />
                        authorised service center.
                      </div>
                    </div>
                    <hr className="m-0 p-0" />
                    <div className="p-4 d-flex align-items-center bgsgray">
                      <div>
                        <LazyLoadImage
                          alt=""
                          effect="blur"
                          className="img-fluid me-2"
                          style={{ maxWidth: "60px" }}
                          src={`/images/warrenty-icon-2.png`}
                        />
                      </div>
                      <div className="f16">
                        Convenient and hassle free service
                        <br /> at 2780 + locations in India.
                      </div>
                    </div>
                    <hr className="m-0 p-0" />
                    <div className="p-4 d-flex align-items-center">
                      <div>
                        <LazyLoadImage
                          alt=""
                          effect="blur"
                          className="img-fluid me-2"
                          style={{ maxWidth: "60px" }}
                          src={`/images/warrenty-icon-3.png`}
                        />
                      </div>
                      <div className="f16">
                        Coverage includes labor cost
                        <br /> and spare parts.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <p className="mt-5 text-center f12">
                *2 Years Extended Warranty is applicable on Select Models only.<br/>
                *Warranty terms and conditions apply.
              </p>
            </div>
          </div>
        </div>
      </div>
      <FotterMain />
    </>
  );
};
export default React.memo(ExtendedWarranty);
